"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackOrderTileClick = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
function trackOrderTileClick(click_url) {
    const eventData = {
        eventName: enums_1.GA4EventName.ClickButton,
        feature_category: enums_1.GA4FeatureCategory.CustomerAccount,
        click_element: 'Order overview click tile',
        click_url,
    };
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventCategory: enums_1.EventCategory.CustomerAccount,
        eventAction: enums_1.ClickEventType.BUTTON_CLICK,
        eventLabel: 'Orders Tile',
        eventValue: undefined,
        nonInteraction: false,
        eventData,
    });
}
exports.trackOrderTileClick = trackOrderTileClick;
//# sourceMappingURL=trackOrderTileClick.js.map